import { useQuery } from "react-query";

import { useApi } from "../../providers/ApiProvider";
import { APQueryOptions, useAPQuery } from "../../providers/APQueryProvider";
import { InvoiceComparisonSummary } from "../../types/Document";

export const getDossierInvoiceComparison = (
  dossierId: string,
  options: APQueryOptions = {}
) => {
  const { fetchWithAuth } = useApi();
  const { isQueryEnabled } = useAPQuery();

  return useQuery({
    queryKey: ["dossierInvoiceComparison", dossierId],
    queryFn: (): Promise<InvoiceComparisonSummary[]> => {
      return fetchWithAuth<InvoiceComparisonSummary[]>(
        "getDossierInvoiceComparison",
        dossierId
      );
    },
    enabled: isQueryEnabled(options),
  });
};
